import { z } from 'zod';

const optionalNumber = z.preprocess(
  (val) => (val === '' || val === undefined || val === null ? undefined : Number(val)),
  z.number().optional(),
);

export const carFormSchema = z.object({
  brand: z.string().min(1, 'Markani tanlang'),
  model: z.string().min(1, 'Modelni kiriting'),
  year: z.coerce.number().min(1990, 'Yilni kiriting').max(new Date().getFullYear() + 1),
  price: z.coerce.number().min(1, 'Narxni kiriting'),
  currency: z.enum(['USD', 'UZS']),
  mileage: optionalNumber,
  fuelType: z.string().min(1, "Yonilg'i turini tanlang"),
  transmission: z.string().min(1, 'Korobkani tanlang'),
  color: z.string().min(1, 'Rangni tanlang'),
  region: z.string().min(1, 'Viloyatni tanlang'),
  district: z.string().optional(),
  contactPhone: z
    .string()
    .min(13, 'Telefon raqamini kiriting')
    .regex(/^\+998\d{9}$/, "Telefon raqami noto'g'ri"),
  description: z.string().optional(),
});

export type CarFormData = z.infer<typeof carFormSchema>;

export const CAR_FORM_DEFAULTS: Partial<CarFormData> = {
  currency: 'USD',
  fuelType: 'PETROL',
  transmission: 'MANUAL',
};
